module.exports = __webpack_public_path__ + "static/between-the-world-and-me-aada85514df864d0aa31731f18d4ac98.jpg";